<template>
  <form
    class="newsletter-view newsletter-details-form"
    @submit.prevent="sendForm()"
  >
    <div class="container pb-5">
      <h1 class="title is-2 has-text-grey">UStID hinterlegen</h1>
    </div>
    <div class="columns is-multiline">
      <div class="column is-full-tablet">
        <div class="field">
          <label class="label is-uppercase mt-3 ml-3"
            >Umsatzsteuer-Identifikationsnummer</label
          >
          <div class="control">
            <input
              v-model="ustID"
              class="input"
              type="text"
              placeholder="DE999999999"
            />
          </div>
        </div>
      </div>
      <div class="column is-full-tablet">
        <div class="buttons is-right mr-4">
          <button
            :disabled="!ustID"
            class="button is-rounded is-primary-dark px-6"
          >
            Absenden
            <SvgIcon
              icon="icon--directional_arrow-right"
              class="is-light ml-5"
            />
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import SvgIcon from "../svg/SvgIcon";
import { eventBus } from "../../events/event-bus";
import axios from "axios";
import convertToFormDataObject from "../../utilities/convert-to-form-data";

export default {
  components: { SvgIcon },
  name: "UStIDForm",
  props: ["details"],
  data() {
    return {
      ustID: "",
      API_URL: "https://3d-print.jomatik.de/rest_api",
    };
  },
  methods: {
    sendForm() {
      axios
        .post(
          this.API_URL + "/ContactForm.php",
          convertToFormDataObject(this.ustIDObject),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then(() => {
          eventBus.$emit("close-modal-event");
          eventBus.notification({
            duration: 15000,
            type: "success",
            header: "Absenden erfolgreich",
            body: "Wir haben Ihre Anfrage erhalten. Wir werden Ihre Umsatzsteuer-Identifikationsnummer in Kürze überprüfen und im System hinterlegen.",
          });
        })
        .catch(function () {
          eventBus.$emit("close-modal-event");
          eventBus.notification({
            type: "warning",
            header: "Hier scheint ein Fehler aufgetreten zu sein.",
            body: "Ihre Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut oder wenden Sie sich an einen Mitarbeiter.",
          });
        });
    },
  },
  computed: {
    ustIDObject() {
      let str =
        "Es liegt eine neue Eintragung der Umsatzsteuer-Identifikationsnummer vor!\n\nName: " +
        this.details.firstName +
        " " +
        this.details.lastName +
        "\nTelefon: " +
        this.details.phone +
        "\nUStID: " +
        this.ustID;
      return {
        subject: "UStID Eintragung",
        mail: " ",
        firstName: this.details.firstName,
        lastName: this.details.lastName,
        message: str,
        confirmation: true,
      };
    },
  },
};
</script>

<style scoped>
</style>